import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { selectRoles } from "../../features/roleSlice";
import { isPathGranted } from "../../utils/routeAccess";

// Admin, or someone given this page on Page Access.
const CheckUserAdmin = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const role = useSelector(selectRoles);

  useEffect(() => {
    if (
      !role?.roles?.includes("Admin") &&
      !isPathGranted(pathname, role?.grantedPaths)
    ) {
      navigate("/");
    }
  }, [role, pathname, navigate]);

  return <></>;
};

export default CheckUserAdmin;
